import type { RiskProfileAsset } from '../types/riskProfileAssets.types'

const ASSET_LABEL_KEY_PRIORITY = ['name', 'assetid', 'asset id', 'asset_id', 'id'] as const

export function resolveLabelKey(sample: RiskProfileAsset): string | null {
  const lookup = new Map<string, string>()
  for (const key of Object.keys(sample.identifying_information)) {
    lookup.set(key.toLowerCase(), key)
  }
  for (const candidate of ASSET_LABEL_KEY_PRIORITY) {
    const original = lookup.get(candidate)
    if (original) return original
  }
  return null
}

export function resolveAssetLabel(asset: RiskProfileAsset, labelKey: string | null): string {
  if (labelKey === null) return asset.aggregate_id
  const value = asset.identifying_information[labelKey]
  if (value == null || String(value).trim() === '') return asset.aggregate_id
  return String(value)
}
